export const fakeLineItem = {
  title: 'Product Name',
  product: { name: 'Product Name' },
  variant_title: 'M / Black',
  price: '29.99',
  currency: 'EUR',
  productIndex: 1,
}

export const reasonKeyMap = {
  'error.item_disabled': 'disabled',
  'error.item_too_old': 'too_old',
  'error.item_not_enough_quantity': 'not_enough_quantity',
  'error.item_unfulfilled': 'unfulfilled',
  'error.item_no_variants': 'no_variants',
}
